module.exports = __webpack_public_path__ + "img/inner_4_bg.4226cd43.png";